import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default class ErrorDialog extends React.Component {

    constructor(props) {
        super(props);
    
        this.state = {
            open: props.open,
            title: props.title,
            text: props.text,
            origprops: props,
        }
    }
    
    onClose = this.props.onClose

    componentDidMount() {
        this.setState({
            open: this.props.open,
            title: this.props.title,
            text: this.props.text,
            origprops: this.props,  
            onClose: this.props.onClose        
        })
    }

    static getDerivedStateFromProps(props, current_state) {
        if (current_state.open !== props.open ||
            current_state.title !== props.title ||
            current_state.text !== props.text ) {
          return {
            open: props.open,
            text: props.text,
            title: props.title
          }
        }
        return null
    }

    handleClose = value => {
        this.setState({open: false, title: '', text: ''})
        this.state.onClose(value)
    }



    render() {
        return (
        <div>
            <Dialog
                open={this.state.open}
                TransitionComponent={Transition}
                onClose={this.handleClose}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">{this.state.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {this.state.text}   
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleClose(true)} color="primary">
                    Ok
                    </Button>
                    <Button onClick={() => this.handleClose(false)} color="primary">
                    Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
        );
    }
}